// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --login-loader-height: 300px;
    --login-loader-width: 300px;
}

/* --------- Login Auth Loader ------- */
.login-page-loader-section {
    height: var(--login-loader-height);
    width: var(--login-loader-width);
    display: flex;
    flex-direction: column;
    column-gap: 10px;
    align-items: center;
    justify-content: center;
    cursor: default;
}

.login-page-loader-section .login-loader-item-group-section:first-child {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.login-page-loader-section .login-loader-item-group-section:first-child .login-loader-item-section:first-child {
    position: absolute;
    height: calc(var(--login-loader-height) - 70px);
    width: calc(var(--login-loader-width) - 70px);
    border-radius: 50%;
    animation: rotate-ring 0.7s linear infinite;
}

.login-page-loader-section .login-loader-item-group-section:first-child .login-loader-item-section:first-child::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    box-shadow: 0 0 5px rgba(255, 255, 255, .3);
    border-radius: 50%;
}

.login-page-loader-section .login-loader-item-group-section:first-child .login-loader-item-section:nth-child(2) {
    position: absolute;
    font: normal normal bold 20px/25px Lato;
    letter-spacing: 1px;
    color: var(--neutral-color1);
    animation: fade-text 3s linear infinite;
}

.login-page-loader-section .login-loader-item-group-section:nth-child(2) {
    font: normal normal 300 20px/25px Lato;
    letter-spacing: 1px;
    color: var(--neutral-color1);
    width: 100%;
    text-align: center;
}

.login-page-loader-note-section {
    font: normal normal normal 14px/20px Lato;
    color: var(--neutral-color1);
    position: absolute;
    bottom: 10px;
    left: 10px;
    letter-spacing: 1px;
    cursor: default;
}

.login-page-loader-note-section span {
    font-weight: bold;
}

/* ----------- Card Loader ------------ */
.card-loader-section, 
.card-details-loader-section {
    height: 70px;
    width: 100%;
    background: var(--neutral-color3) 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px var(--border-shadow-color2);
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    animation: card-loading1 2s linear infinite;
}

.card-loader-section .card-loader-item-section,
.card-details-loader-section .card-loader-item-section {
    width: 100%;
    height: 100%;
    animation: card-loading 1s linear infinite;
}

.card-loader-section .card-loader-item-section .card-loader-item,
.card-details-loader-section .card-loader-item-section .card-loader-item {
    width: 50%;
    height: 100%;
    background: var(--neutral-color3) 0% 0% no-repeat padding-box;
    transform: skewX(-20deg) !important;
    filter: blur(10px);
    -webkit-filter: blur(10px);
}

/* ----------- Card Details Loader ------------ */
.card-details-loader-section{
    height: 55vh;
}


/* -------- Api call Action Loadder ---------- */
.api-action-loader-item-section{
    position: absolute;
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--bg-api-loader) 0% 0% no-repeat padding-box;
    z-index: 9999;    
}
.api-action-loader-item-section .api-action-loader-item:first-child{
    position: absolute;
    height: 200px;
    width: 200px;
    border-radius: 50%;
    animation: rotate-ring 1s linear infinite;
}
.api-action-loader-item-section .api-action-loader-item:first-child::before{
    position: absolute;
    content: "";
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    border-radius: 50%;
    box-shadow: 0px 0px 6px var(--neutral-color1);
}
.api-action-loader-item-section .api-action-loader-item:last-child{
    position: absolute;
    font: normal normal bold 17px/21px Lato;
    letter-spacing: 0px;
    color: var(--neutral-color1);
    /* animation: fade-text 1.5s linear infinite; */
}

@keyframes rotate-ring {
    0% {
        transform: rotate(0deg);
        box-shadow: 1px 5px 2px var(--indicators-yellow);
    }

    50% {
        transform: rotate(180deg);
        box-shadow: 1px 5px 2px var(--indicators-yellow);
    }

    100% {
        transform: rotate(360deg);
        box-shadow: 1px 5px 2px var(--indicators-yellow);
    }
}

@keyframes rotate-ring-blue {
    0% {
        transform: rotate(0deg);
        box-shadow: 1px 5px 2px var(--call-to-action1);
    }

    50% {
        transform: rotate(180deg);
        box-shadow: 1px 5px 2px var(--call-to-action1);
    }

    100% {
        transform: rotate(360deg);
        box-shadow: 1px 5px 2px var(--call-to-action1);
    }
}

@keyframes fade-text {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes card-loading {
    0% {
        transform: translateX(-150%);
    }

    100% {
        transform: translateX(150%);
    }
}

@keyframes card-loading1 {
    0% {
        background-color: hsl(210, 2%, 76%);
    }

    50% {
        background-color: hsl(0, 2%, 90%);
    }

    100% {
        background-color: hsl(210, 2%, 76%);
    }
}


/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    .card-loader-section{
        height: 150px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/Loader.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA,wCAAwC;AACxC;IACI,kCAAkC;IAClC,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,6CAA6C;IAC7C,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,mBAAmB;IACnB,4BAA4B;IAC5B,uCAAuC;AAC3C;;AAEA;IACI,sCAAsC;IACtC,mBAAmB;IACnB,4BAA4B;IAC5B,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,4BAA4B;IAC5B,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,yCAAyC;AACzC;;IAEI,YAAY;IACZ,WAAW;IACX,6DAA6D;IAC7D,mDAAmD;IACnD,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;;IAEI,UAAU;IACV,YAAY;IACZ,6DAA6D;IAC7D,mCAAmC;IACnC,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA,iDAAiD;AACjD;IACI,YAAY;AAChB;;;AAGA,gDAAgD;AAChD;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4DAA4D;IAC5D,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,yCAAyC;AAC7C;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,6CAA6C;AACjD;AACA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,mBAAmB;IACnB,4BAA4B;IAC5B,+CAA+C;AACnD;;AAEA;IACI;QACI,uBAAuB;QACvB,gDAAgD;IACpD;;IAEA;QACI,yBAAyB;QACzB,gDAAgD;IACpD;;IAEA;QACI,yBAAyB;QACzB,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,8CAA8C;IAClD;;IAEA;QACI,yBAAyB;QACzB,8CAA8C;IAClD;;IAEA;QACI,yBAAyB;QACzB,8CAA8C;IAClD;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,mCAAmC;IACvC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,mCAAmC;IACvC;AACJ;;;AAGA,wCAAwC;AACxC;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[":root {\r\n    --login-loader-height: 300px;\r\n    --login-loader-width: 300px;\r\n}\r\n\r\n/* --------- Login Auth Loader ------- */\r\n.login-page-loader-section {\r\n    height: var(--login-loader-height);\r\n    width: var(--login-loader-width);\r\n    display: flex;\r\n    flex-direction: column;\r\n    column-gap: 10px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: default;\r\n}\r\n\r\n.login-page-loader-section .login-loader-item-group-section:first-child {\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: relative;\r\n}\r\n\r\n.login-page-loader-section .login-loader-item-group-section:first-child .login-loader-item-section:first-child {\r\n    position: absolute;\r\n    height: calc(var(--login-loader-height) - 70px);\r\n    width: calc(var(--login-loader-width) - 70px);\r\n    border-radius: 50%;\r\n    animation: rotate-ring 0.7s linear infinite;\r\n}\r\n\r\n.login-page-loader-section .login-loader-item-group-section:first-child .login-loader-item-section:first-child::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    box-shadow: 0 0 5px rgba(255, 255, 255, .3);\r\n    border-radius: 50%;\r\n}\r\n\r\n.login-page-loader-section .login-loader-item-group-section:first-child .login-loader-item-section:nth-child(2) {\r\n    position: absolute;\r\n    font: normal normal bold 20px/25px Lato;\r\n    letter-spacing: 1px;\r\n    color: var(--neutral-color1);\r\n    animation: fade-text 3s linear infinite;\r\n}\r\n\r\n.login-page-loader-section .login-loader-item-group-section:nth-child(2) {\r\n    font: normal normal 300 20px/25px Lato;\r\n    letter-spacing: 1px;\r\n    color: var(--neutral-color1);\r\n    width: 100%;\r\n    text-align: center;\r\n}\r\n\r\n.login-page-loader-note-section {\r\n    font: normal normal normal 14px/20px Lato;\r\n    color: var(--neutral-color1);\r\n    position: absolute;\r\n    bottom: 10px;\r\n    left: 10px;\r\n    letter-spacing: 1px;\r\n    cursor: default;\r\n}\r\n\r\n.login-page-loader-note-section span {\r\n    font-weight: bold;\r\n}\r\n\r\n/* ----------- Card Loader ------------ */\r\n.card-loader-section, \r\n.card-details-loader-section {\r\n    height: 70px;\r\n    width: 100%;\r\n    background: var(--neutral-color3) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 0px 6px var(--border-shadow-color2);\r\n    border-radius: 6px;\r\n    overflow: hidden;\r\n    position: relative;\r\n    animation: card-loading1 2s linear infinite;\r\n}\r\n\r\n.card-loader-section .card-loader-item-section,\r\n.card-details-loader-section .card-loader-item-section {\r\n    width: 100%;\r\n    height: 100%;\r\n    animation: card-loading 1s linear infinite;\r\n}\r\n\r\n.card-loader-section .card-loader-item-section .card-loader-item,\r\n.card-details-loader-section .card-loader-item-section .card-loader-item {\r\n    width: 50%;\r\n    height: 100%;\r\n    background: var(--neutral-color3) 0% 0% no-repeat padding-box;\r\n    transform: skewX(-20deg) !important;\r\n    filter: blur(10px);\r\n    -webkit-filter: blur(10px);\r\n}\r\n\r\n/* ----------- Card Details Loader ------------ */\r\n.card-details-loader-section{\r\n    height: 55vh;\r\n}\r\n\r\n\r\n/* -------- Api call Action Loadder ---------- */\r\n.api-action-loader-item-section{\r\n    position: absolute;\r\n    height: 100vh;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: var(--bg-api-loader) 0% 0% no-repeat padding-box;\r\n    z-index: 9999;    \r\n}\r\n.api-action-loader-item-section .api-action-loader-item:first-child{\r\n    position: absolute;\r\n    height: 200px;\r\n    width: 200px;\r\n    border-radius: 50%;\r\n    animation: rotate-ring 1s linear infinite;\r\n}\r\n.api-action-loader-item-section .api-action-loader-item:first-child::before{\r\n    position: absolute;\r\n    content: \"\";\r\n    left: 0;\r\n    top: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    border-radius: 50%;\r\n    box-shadow: 0px 0px 6px var(--neutral-color1);\r\n}\r\n.api-action-loader-item-section .api-action-loader-item:last-child{\r\n    position: absolute;\r\n    font: normal normal bold 17px/21px Lato;\r\n    letter-spacing: 0px;\r\n    color: var(--neutral-color1);\r\n    /* animation: fade-text 1.5s linear infinite; */\r\n}\r\n\r\n@keyframes rotate-ring {\r\n    0% {\r\n        transform: rotate(0deg);\r\n        box-shadow: 1px 5px 2px var(--indicators-yellow);\r\n    }\r\n\r\n    50% {\r\n        transform: rotate(180deg);\r\n        box-shadow: 1px 5px 2px var(--indicators-yellow);\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(360deg);\r\n        box-shadow: 1px 5px 2px var(--indicators-yellow);\r\n    }\r\n}\r\n\r\n@keyframes rotate-ring-blue {\r\n    0% {\r\n        transform: rotate(0deg);\r\n        box-shadow: 1px 5px 2px var(--call-to-action1);\r\n    }\r\n\r\n    50% {\r\n        transform: rotate(180deg);\r\n        box-shadow: 1px 5px 2px var(--call-to-action1);\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(360deg);\r\n        box-shadow: 1px 5px 2px var(--call-to-action1);\r\n    }\r\n}\r\n\r\n@keyframes fade-text {\r\n    0% {\r\n        opacity: 1;\r\n    }\r\n\r\n    50% {\r\n        opacity: 0;\r\n    }\r\n\r\n    100% {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes card-loading {\r\n    0% {\r\n        transform: translateX(-150%);\r\n    }\r\n\r\n    100% {\r\n        transform: translateX(150%);\r\n    }\r\n}\r\n\r\n@keyframes card-loading1 {\r\n    0% {\r\n        background-color: hsl(210, 2%, 76%);\r\n    }\r\n\r\n    50% {\r\n        background-color: hsl(0, 2%, 90%);\r\n    }\r\n\r\n    100% {\r\n        background-color: hsl(210, 2%, 76%);\r\n    }\r\n}\r\n\r\n\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    .card-loader-section{\r\n        height: 150px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
